// extracted by mini-css-extract-plugin
export default {"MemberNationality":"style_MemberNationality__fAY0Y"};